import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Plans from "../components/Plans";

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-black text-white" id="top">
      <Header />
      <Hero />
      <Plans />
      <footer className="py-12 border-t border-white/5">
        <div className="max-w-6xl mx-auto px-6 flex flex-col items-center gap-5">
          <a
            href="https://discord.gg/CFWgP3VG2g"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-2.5 px-5 py-2.5 rounded-xl border border-[#5865F2]/40 bg-[#5865F2]/10 hover:bg-[#5865F2]/20 hover:border-[#5865F2]/70 text-white text-sm font-semibold transition-all hover:-translate-y-0.5"
          >
            <svg
              className="w-5 h-5 text-[#5865F2] group-hover:text-white transition-colors"
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M20.317 4.369A19.79 19.79 0 0 0 16.558 3c-.164.295-.355.694-.487 1.01a18.27 18.27 0 0 0-5.487 0A12.9 12.9 0 0 0 10.09 3a19.74 19.74 0 0 0-3.76 1.37C2.665 9.943 1.843 15.385 2.254 20.75a19.9 19.9 0 0 0 5.99 3.023c.484-.664.916-1.37 1.288-2.113a12.86 12.86 0 0 1-2.032-.973c.17-.126.336-.257.497-.393 3.936 1.826 8.2 1.826 12.086 0 .163.136.329.267.497.393a12.9 12.9 0 0 1-2.036.975c.373.743.804 1.45 1.288 2.113a19.86 19.86 0 0 0 5.994-3.023c.5-6.19-.846-11.585-3.508-16.383zM9.538 17.156c-1.185 0-2.157-1.086-2.157-2.418 0-1.331.953-2.418 2.157-2.418s2.177 1.087 2.157 2.418c0 1.332-.953 2.418-2.157 2.418zm4.924 0c-1.185 0-2.157-1.086-2.157-2.418 0-1.331.952-2.418 2.157-2.418 1.205 0 2.176 1.087 2.157 2.418 0 1.332-.952 2.418-2.157 2.418z" />
            </svg>
            Join Our Discord Community
          </a>
          <div className="text-center text-white/40 text-sm">
            © {new Date().getFullYear()} BKS Wholesale. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
}
